export { default as BuildBundlesModalController } from './BuildBundlesModalController';
export { BuildBundlesModal }                      from './BuildBundlesModal';



// WEBPACK FOOTER //
// ./src/components/buildBundlesModal/index.js